var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInpatient = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Inpatient"
}, /*#__PURE__*/React.createElement("path", {
  id: "Union",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.6739 2.68022V22.4238H11.6831V14.0016H5.40216V22.4238H3.36516V2.68022C3.36516 2.07037 3.77141 1.57623 4.26985 1.57623H12.7693C13.2677 1.57623 13.6739 2.07037 13.6739 2.68022ZM1.91306 2.68022V22.4238H0V24H24V22.4238H21.9516V9.31041C21.9516 8.2377 21.1795 7.36514 20.2316 7.36514H15.126V2.68022C15.126 1.20094 14.0687 0 12.7693 0H4.26985C2.97045 0 1.91306 1.20094 1.91306 2.68022ZM15.126 8.94138V22.4238H20.4995V9.31041C20.4995 9.11338 20.3756 8.94138 20.2316 8.94138H15.126ZM9.52797 10.1235V7.89054H11.5851V5.83894H9.52797V3.60594H7.63793V5.83894H5.58079V7.89054H7.63793V10.1235H9.52797ZM18.9724 10.5895H16.6502V12.8726H18.9724V10.5895ZM18.9724 14.4707H16.6502V16.7537H18.9724V14.4707ZM18.9724 18.3487H16.6502V20.6317H18.9724V18.3487Z",
  fill: "currentColor"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInpatient);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/inpatient.2f3680c4633fe149503ebf1ab2ddbb30.svg";